import { render, staticRenderFns } from "./EmployeesSliceActivate.vue?vue&type=template&id=328fc348&scoped=true&"
import script from "./EmployeesSliceActivate.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328fc348",
  null
  
)

export default component.exports